"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _video = _interopRequireDefault(require("video.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Plugin = _video["default"].getPlugin('plugin');
var BookmarksPlugin = /*#__PURE__*/function (_Plugin) {
  function BookmarksPlugin(player, options) {
    var _this;
    _classCallCheck(this, BookmarksPlugin);
    _this = _callSuper(this, BookmarksPlugin, [player, options]);
    _this.player = player;
    _this.bookmarks = options && options.bookmarks || [];
    _this.eventUrl = options && options.eventUrl || '';
    _this.markers = [];
    _this.player.on('loadedmetadata', function () {
      _this.setupBookmarks();
    });
    return _this;
  }
  _inherits(BookmarksPlugin, _Plugin);
  return _createClass(BookmarksPlugin, [{
    key: "setupBookmarks",
    value: function setupBookmarks() {
      var _this2 = this;
      var controlBar = this.player.controlBar;
      var progressControl = controlBar.progressControl;
      var seekBar = progressControl.seekBar;
      if (this.bookmarks) {
        this.bookmarks.forEach(function (_ref) {
          var timecode = _ref.timecode,
            tooltip = _ref.tooltip;
          if (timecode < 0 || !_this2.player.duration() || timecode > _this2.player.duration()) {
            return;
          }
          var cuePoint = timecode / _this2.player.duration() * 100;
          var marker = document.createElement('div');
          marker.dataset.timecode = timecode;
          marker.dataset.eventUrl = _this2.eventUrl;
          marker.style.position = 'absolute';
          marker.style.left = "calc(".concat(cuePoint, "% - 3px)");
          marker.style.top = '-11px';
          marker.style.width = '6px';
          marker.style.height = '6px';
          marker.style.backgroundColor = 'white';
          marker.style.borderRadius = '50%';
          marker.style.cursor = 'pointer';

          // Create tooltip
          var tooltipEl = document.createElement('div');
          tooltipEl.textContent = tooltip;
          tooltipEl.style.position = 'absolute';
          tooltipEl.style.bottom = '30px';
          tooltipEl.style.left = '50%';
          tooltipEl.style.transform = 'translateX(-50%)';
          tooltipEl.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltipEl.style.color = 'white';
          tooltipEl.style.padding = '5px 10px';
          tooltipEl.style.borderRadius = '4px';
          tooltipEl.style.fontSize = '12px';
          tooltipEl.style.whiteSpace = 'nowrap';
          tooltipEl.style.display = 'none';
          tooltipEl.style.zIndex = '1000';
          marker.appendChild(tooltipEl);

          // Show/hide tooltip on hover
          marker.addEventListener('mouseenter', function (event) {
            tooltipEl.style.display = 'block';
          });
          marker.addEventListener('mouseleave', function () {
            tooltipEl.style.display = 'none';
          });
          marker.addEventListener('contextmenu', function (event) {
            event.preventDefault(); // Prevent default context menu from appearing

            var contextMenu = document.createElement('div');
            contextMenu.style.position = 'fixed';
            contextMenu.style.left = "".concat(event.clientX, "px");
            contextMenu.style.top = "".concat(event.clientY, "px");
            contextMenu.style.background = 'rgba(28, 28, 28, .9)';
            contextMenu.style.borderRadius = '2px';
            contextMenu.style.padding = '10px';
            contextMenu.style.zIndex = '10000';
            var menuItem = document.createElement('div');
            menuItem.textContent = 'Copy video URL at current time';
            menuItem.style.color = 'white';
            menuItem.style.fontSize = '11px';
            menuItem.style.cursor = 'pointer';
            menuItem.style.userSelect = 'none';
            menuItem.addEventListener('click', function () {
              var url = "".concat(marker.dataset.eventUrl + marker.dataset.timecode);
              try {
                navigator.clipboard.writeText(url);
                console.log("".concat(marker.dataset.eventUrl + marker.dataset.timecode));
              } catch (err) {
                console.error('Could not copy text: ', err);
              }
            });
            contextMenu.appendChild(menuItem);
            document.body.appendChild(contextMenu);
            document.addEventListener('click', function removeContextMenu() {
              document.body.removeChild(contextMenu);
              document.removeEventListener('click', removeContextMenu);
            });
          });
          seekBar.el().appendChild(marker);
          _this2.markers.push(marker);
        });
      }
    }
  }, {
    key: "updateBookmarks",
    value: function updateBookmarks(bookmarks) {
      this.bookmarks = bookmarks;
      this.dispose();
      this.setupBookmarks();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var controlBar = this.player.controlBar;
      var progressControl = controlBar.progressControl;
      var seekBar = progressControl.seekBar;
      this.markers.forEach(function (marker) {
        seekBar.el().removeChild(marker);
      });
      this.markers = [];
    }
  }]);
}(Plugin);
_video["default"].registerPlugin('bookmarksPlugin', BookmarksPlugin);
var _default = exports["default"] = BookmarksPlugin;